angular.module('leanlaw').controller('ClientMatterRevenueCtrl', ['$scope', '$q', '$filter', '$rootScope', '$state', "alerts", 'userService', 'reportsService', 'accountingService', "exportJson", "singleRequest", "messageBus", "lists", function ($scope, $q, $filter, $rootScope, $state, alerts, userService, reportsService, accountingService, exportJson, singleRequest, messageBus, lists) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.billingType = matter => lists.billingTypeFromId(matter.billing.type);
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.loading = true;
  $scope.print = function () {
    window.print();
  };
  function exportLine(client, matter, data, total) {
    const include = $scope.filter.include;
    let line = {};
    if ($scope.clientReferences || $scope.references && $scope.filter.include && $scope.filter.include.matters) {
      line = {
        "ID": client.client.reference,
        "Client": client.client.name
      };
    } else {
      line = {
        "Client": client.client.name
      };
    }
    if (include.matters) {
      if ($scope.references) {
        line["ID"] = matter && matter.matter.reference ? matter.matter.reference.indexOf('.') > -1 ? `="${matter.matter.reference}"` : matter.matter.reference : '';
      }
      line[$scope.me.terms.Matter] = matter && matter.matter.name;
      line["Type"] = matter && lists.billingTypeFromId(matter.matter.billing.type);
    }
    if (matter) {
      line["Responsible"] = matter.matter.primary.initials || matter.matter.primary.name;
    } else {
      line["Responsible"] = client.responsibles.map(r => r.initials || r.name).join(', ');
    }
    if (include.detail && $scope.filter.show.billed) {
      line["Billed Hours"] = data.billed ? $filter("amount")(data.billed.hours) : '';
      line["Billed Expenses"] = data.billed ? $filter("amount")(data.billed.expensesTotal) : '';
      line["Billed Fixed fees"] = data.billed ? $filter("amount")(data.billed.chargesTotal) : '';
      line["Billed Credits"] = data.billed ? $filter("amount")(data.billed.credits) : '';
      if (total.billed && total.billed.adjustments) {
        line["Adjustments"] = data.billed ? $filter("amount")(data.billed.adjustments) : '';
      }
      if (total.billed && total.billed.tax) {
        line["Tax"] = data.billed ? $filter("amount")(data.billed.tax) : '';
      }
    }
    if ($scope.filter.show.billed) {
      const label = include.detail ? "Total Billed" : "Billed";
      line[label] = data.billed ? $filter("amount")(data.billed.total) : '';
    }
    line.Collected = data.collected.total ? $filter("amount")(data.collected.total) : '';
    if ($scope.data.data.collected.credits) {
      line["Writeoff"] = data.collected.credits ? $filter("amount")(data.collected.credits) : '';
    }
    if ($scope.accounting && $scope.trust) {
      line["Trust balance"] = data.accounting && data.accounting.trustBalance ? $filter("amount")(data.accounting.trustBalance) : "";
    }
    if ($scope.accounting) {
      line["Receivables balance"] = data.accounting && data.accounting.balance ? $filter("amount")(data.accounting.balance) : "";
    }
    return line;
  }
  $scope.export = function () {
    const exp = $scope.data.filteredClients.reduce((accum, c) => {
      accum.push(exportLine(c, null, c.data, $scope.data.data));
      if ($scope.filter.include.matters) {
        c.matters.forEach(m => {
          accum.push(exportLine(c, m, m.data, $scope.data.data));
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  $scope.goToSummary = function (clientId, matterId) {
    $state.go("reports.client-matter-revenue-invoices", {
      clientId,
      matterId
    });
  };
  activate();

  ///////////////////////////////////////

  function activate() {
    userService.me().then(me => {
      $scope.ready = true;
      $scope.trust = me.company.settings.trustEnabled;
      accountingService.verify(false).then(state => {
        $scope.accounting = state.connected;
      }).finally(() => {
        filterClientEntries();
      });
    });
  }
  function filterClientEntries() {
    if (!$scope.ready) return;
    $scope.loading = true;
    $scope.data = null;
    const query = reportsService.queryFromFilter($scope.filter);
    query.primary = 'clients';
    query.billingType = '-internal';
    query.data = "invoices";
    query.zeros = $scope.filter.include && $scope.filter.include.norevenue;
    query.reportType = "revenue";
    if ($scope.accounting) {
      query.data += ',payments';
      loadBalances();
    }
    if (!$scope.filter.show.billed) {
      query.data = "payments";
    }
    $q.when(singleRequest.apiCall("client-matter-revenue", true).getReport(query)).then(data => {
      if (!data) return;
      $scope.data = data;
      $scope.responsible = false;
      $scope.loading = false;
      $scope.clientReferences = data.clients.some(c => c.client.reference);
      $scope.references = data.clients.some(c => c.matters.some(m => m.matter.reference));
      mergeAccounting();
      $scope.data.clients.forEach(client => {
        if (client.client.reference) {
          $scope.responsible = true;
        }
        const responsible = client.matters.reduce((acc, m) => {
          acc[m.matter.primary.id] = m.matter.primary;
          return acc;
        }, {});
        client.responsibles = Object.keys(responsible).map(id => responsible[id]);
      });
      // return $scope.data;
    }).catch(err => {
      alerts.error(err);
      $scope.loading = false;
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("client-matter-revenue");
    singleRequest.cancel("client-matter-revenue-balances");
    deactivate();
  });
  function loadBalances() {
    $scope.loadingBalances = true;
    const query = reportsService.queryFromFilter($scope.filter);
    query.primary = 'clients';
    query.billingType = '-internal';
    query.data = "receivables";
    query.reportType = "revenue";
    query.zeros = false;
    if ($scope.trust) {
      query.data += ",trust";
    }
    $scope.localAccounting = null;
    return singleRequest.apiCall("client-matter-revenue-balances", true).getReport(query).then(data => {
      if (!data) return;
      $scope.localAccounting = data;
      $scope.loadingBalances = false;
      mergeAccounting();
    }).catch(err => {
      alerts.error(err);
      $scope.loadingBalances = false;
    });
  }
  function mergeAccounting() {
    // This merges the trust and receivables balances into the main object
    // (they are loaded separately because the trust/receivables can be slow due to the fact that it interfaces with QBO)
    if ($scope.loadingBalances || $scope.loading || !$scope.localAccounting || !$scope.data) return;
    $scope.localAccounting.clients.forEach(client => {
      const targetClient = $scope.data.clients.find(c => c.client.id === client.client.id);
      if (targetClient) {
        targetClient.data.accounting = angular.copy(client.data.accounting);
        client.matters.forEach(matter => {
          const targetMatter = targetClient.matters.find(m => m.matter.id === matter.matter.id);
          if (targetMatter) {
            targetMatter.data.accounting = angular.copy(matter.data.accounting);
          }
        });
      }
    });
  }
  $scope.$on('commonFilterService-statechanged', (event, payload) => {
    if (!payload) return;
    // Assigning to existing filter keeps custom filter options
    $scope.filter = Object.assign($scope.filter, payload);
    // Necessary to set this value for the requests
    $scope.filter.status = $scope.filter.archived.status;
    $scope.filter.scope = $scope.filter.filter.scope;
    // if (payload.filter.range) {
    filterClientEntries();
    // }
  });
  $scope.$on("report-clientmatter-change", (event, cm) => {
    singleRequest.cancel("filterClientEntries");
    singleRequest.cancel("loadBalances");
    $scope.goToSummary(cm.client ? cm.client.id : null, cm.matter ? cm.matter.id : null);
  });
  let localNorevenue = false;
  $scope.$on("report-sidebar-filterchange", (event, payload) => {
    const changed = payload.include.norevenue !== localNorevenue;
    localNorevenue = payload.include.norevenue;
    $scope.filter = Object.assign($scope.filter, payload);
    if (changed) {
      filterClientEntries();
    }
  });
  $scope.$watch('filter.include.accounting', show => {
    if (show) {
      filterClientEntries();
    }
  }, true);

  // MessageBus is used here so that the commonFilter module can pick it up once it loads
  messageBus.addMessage("filterDependency-ready", true);
  messageBus.addMessage("clientmatter-set", true, {});
}]);